export default "__VITE_ASSET___71D$$v2__"